
<template>
  <form
    aria-labelledby="customer-admin-users-groupIdheader"
    @submit.prevent="save"
  >
    <h2
      id="customer-admin-users-groupIdheader"
    >
      <span v-if="group">
        <router-link :to="{ name: 'customer-admin-users-groupId', params: {groupId: group.groupId } }">
          {{ group.name }}
        </router-link> |
      </span>
      {{ user.name }} / {{ user.email }}
      | Roles
    </h2>
    <table class="table table-striped table-bordered table-condensed">
      <caption>Roles for {{ user.email }}</caption>
      <thead>
        <tr>
          <th
            width="30%"
            scope="col"
          >
            Group
          </th>
          <th
            width="15%"
            scope="col"
          >
            Roles
          </th>
          <th
            v-if="!org.hasPerpetualFreeDuration"
            width="18%"
            scope="col"
          >
            Free Duration for {{ (isEdu) ? 'Student' : 'Speaker' }} Access
          </th>
          <th
            width="18%"
            scope="col"
          >
            Start Date
          </th>
          <th
            v-if="org.billingModel != 1"
            width="19%"
            scope="col"
          >
            Access Expires
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="role in roles">
          <td>
            {{ role.groupName }}
          </td>
          <td>
            <label
              v-if="role.groupId !== null"
              class="checkbox-inline"
              :for="role.groupId + 'speakerAccess'"
            >
              <input
                :id="role.groupId + 'speakerAccess'"
                v-model="role.roles"
                :disabled="isDisabled(role)"
                type="checkbox"
                value="speaker"
              >{{ (isEdu) ? 'Student' : 'Speaker' }}
            </label>
            <label
              v-if="role.groupId !== null"
              class="checkbox-inline"
              :for="role.groupId + 'coachAccess'"
            >
              <input
                :id="role.groupId + 'coachAccess'"
                v-model="role.roles"
                type="checkbox"
                value="manager"
              >{{ (isEdu) ? 'Instructor' : 'Coach' }}
            </label>
          </td>
          <td v-if="!org.hasPerpetualFreeDuration">
            {{ getFreeDuration(role.groupId) || '&mdash;' }}
          </td>
          <td>
            <span v-if="role.membershipStartDate">
              {{ role.membershipStartDate | dateShort }}
            </span>
          </td>
          <td v-if="org.billingModel != 1">
            <span v-if="role.membershipExpires && role.membershipStatus === 'inactive'">
              Access as {{ role.expiredRoles.join(', ') }} expired on {{ role.membershipExpires | dateShort }}
            </span>
            <span v-else-if="role.membershipPerpetual || (org.hasPerpetualFreeDuration && role.membershipStatus === 'active')">
              Perpetual Access / No expiration
            </span>
            <span v-else-if="(!org.hasPerpetualFreeDuration && role.membershipExpires && role.membershipStatus === 'active')">
              {{ role.membershipExpires | dateShort }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <input
      id="orgManager"
      v-model="isOrgManager"
      name="orgManager"
      type="checkbox"
    >
    <label for="orgManager">
      Allow this user to add new {{ (isEdu) ? 'classes' : 'groups' }}?
    </label>
    <br>
    <input
      id="orgAdmin"
      v-model="isOrgAdmin"
      name="orgAdmin"
      type="checkbox"
    >
    <label for="orgAdmin">
      Make this user an admin with full admin access?
    </label>
    <br><br>
    <button
      class="btn btn-primary"
      type="submit"
    >
      Save
    </button>
  </form>
</template>

<script>
import api from '../../services/users';

export default {
  props: {
    org: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      //required: true
    },
    user: {
      type: Object,
      required: true
    },
    isEdu: {
      type: Boolean,
      default: false
    },
    groups: {
      type: Array,
      required: true
    },
    groupIdsToNames: {},
  },
  data() {
    return {
      rolesLoaded: null,
      isOrgAdmin: false,
      isOrgManager: false,
      roles: [],
    };
  },
  computed: {
  },
  updated() {
    this.loadRoles();
  },
  created() {
    this.loadRoles();
  },
  updated() {
    this.loadRoles();
  },
  methods: {
    isDisabled(role) {
      const isExpired = !!(role.expiredRoles && role.expiredRoles.length);
      const group = this._.find(this.groups, {groupId: role.groupId});

      if (isExpired && this.org.billingModel == 0) {
        return true;
      }
      if ((this.org.settings && this.org.settings.freeDuration) ||
        (group && group.settings && group.settings.freeDuration)) {
        return false;
      }
      return true;
    },
    getFreeDuration(groupId) {
      const group = this._.find(this.groups, {groupId});
      if (group && group.settings && group.settings.freeDuration) {
        return this.$options.filters.momentDuration(group.settings.freeDuration);
      } else if (this.org && this.org.settings && this.org.settings.freeDuration) {
        return this.$options.filters.momentDuration(this.org.settings.freeDuration);
      }
      return false;
    },
    loadRoles() {
      if (this.rolesLoaded === this.user.userId) {
        return true;
      }
      // Restore defaults
      this.isOrgManager = false;
      this.isOrgAdmin = false;

      const roles = this._.map(this.groups, group => {
        const role = this._.merge({
          groupId: group.groupId,
          groupName: group.name,
          roles: [],
          membershipStartDate: null,
          membershipExpires: null,
          membershipPerpetual: false
        }, this._.find(this.user.groups, role => role.groupId === group.groupId));
        return role;
      });
      this.rolesLoaded = this.user.userId;
      this._.forEach(roles, (role) => {
        if (role.membershipExpires && role.membershipStatus === 'inactive') {
          role.expiredRoles = this._.cloneDeep(role.roles);
          role.roles = [];
        }
      });
      this.roles = roles;

      // Populate initial state of checkboxes
      if (this.user.groups && this.user.groups['00000000-0000-4000-0000-000000000000'] &&
            this.user.groups['00000000-0000-4000-0000-000000000000'].isOrgAdmin) {
        this.isOrgAdmin = true;
      }
      if (this.user.groups && this.user.groups['00000000-0000-4000-0000-000000000000'] &&
          this.user.groups['00000000-0000-4000-0000-000000000000'].isOrgManager) {
        this.isOrgManager = true;
      }
    },
    save() {
      this.saving = true;
      this.errors = [];

      // Build form submissions
      let roles = this._.filter(this._.clone(this.roles), (role) => {
        // Do not send to the backend anything which is only expiredRoles which they did not modify
        return !(role.expiredRoles && role.expiredRoles.length && role.roles && !role.roles.length);
      });

      let orgRoles;
      if (this.isOrgAdmin) {
        orgRoles = ['admin', 'manager'];
      } else if (this.isOrgManager) {
        orgRoles = ['manager'];
      } else {
        orgRoles = [];
      }
      const orgRole = {
        groupId: '00000000-0000-4000-0000-000000000000',
        roles: orgRoles,
      };
      roles.push(orgRole);

      let user = this.$store.getters.user;
      if (this.user.userId === user.userId && orgRoles.indexOf('admin') === -1) {
        if (!window.confirm('You are removing admin access from the currently logged in account. '+
            'If you proceed, you will not be able to restore this access and will no longer '+
            'be an admin. Proceed?')) {
          return false;
        }
      }

      api.update(this.user.userId, {roles})
        .then(() => {
          this.$store.dispatch('notify', {
            type: 'success',
            subject: 'Changes Saved',
            text: 'All changes to the user have been saved.'
          });

          // Update the parent data
          this.rolesLoaded = null;

          this.$store.dispatch('listGroupMembers', true).then(() => {
            this.$emit('userUpdate');
          });
        })
        .catch((response) => {
          if (response && response[0] && response[0].$status === 402) {
            return this.$store.dispatch('notify', {
              type: 'error',
              subject: 'Could not save changes',
              text: 'You are already using your maximum number of speaker seats. ' +
                'Please either contact VoiceVibes to arrange for an upgrade ' +
                'or deactivate a non-coach speaker seat to free up a license.',
            });
          }
          this.$store.dispatch('notify', {
            type: 'error',
            subject: 'Could not save changes',
            text: 'Please reload the page and try again.',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
